import script from "./ExplainerSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ExplainerSection.vue?vue&type=script&setup=true&lang=js"

import "./ExplainerSection.vue?vue&type=style&index=0&id=1864d4b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1864d4b4"]])

export default __exports__